import Header from '../constant-screens/header';
import Navbar from '../constant-screens/navbar';
import Footer from '../constant-screens/footer';
import AidsScreenBody from '../half-screens/aidsScreenBody';

function AidScreen() {
 return(
  <div>
   <Header />
   <Navbar />
   <AidsScreenBody />
   <Footer />
  </div>
 );
}

export default AidScreen;